export enum ProfileEnum {
    ADMIN = 'ADMIN',
    USER = 'USER'
}

export namespace ProfileEnum {
    export function getFullAccess(): ProfileEnum[] {
        return [ProfileEnum.ADMIN, ProfileEnum.USER];
    }
}

export enum RolesEnum {
    DEFAULT,
    READ,
    WRITE,
    EXCLUDE,
}

export const RolesEnumOptions = [
    { label: 'Sem permissão', value: RolesEnum.DEFAULT.toString() },
    { label: 'Leitura', value: RolesEnum.READ.toString() },
    { label: 'Leitura e escrita', value: RolesEnum.WRITE.toString() },
    { label: 'Acesso total (leitura, escrita e exclusão)', value: RolesEnum.EXCLUDE.toString() },
];
